import { render, staticRenderFns } from "./NavbarNav.vue?vue&type=template&id=23b42cf3&"
import script from "./NavbarNav.vue?vue&type=script&lang=js&"
export * from "./NavbarNav.vue?vue&type=script&lang=js&"
import style0 from "./NavbarNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports